import Application from './application/Application';
import { ProductService } from './services/productService/ProductService';
import { BasketService } from './services/basket/BasketService';
import { ApplicationContext, IApplicationContext } from './framework/framework/shared/ApplicationContext';
import { AccountService } from './services/accountService/AccountService';
import React = require('react');
import ReactDOM = require('react-dom');

const root = document.getElementById('app');

if (root !== undefined && root != null) {
    const appCtx = (window as any).applicationContext as IApplicationContext;
    const appCtxObject = new ApplicationContext(appCtx);
    const appName = (window as any).applicationContext.applicationName;
    const buildTime = (window as any).applicationContext.buildTime;
    const isProd = (appCtx as any).isTestVersion || '';
    ProductService.init(appCtxObject);
    BasketService.init(appCtxObject);
    AccountService.init(appCtxObject);
    ReactDOM.render(
        <Application appCtx={appCtxObject} appName={appName} buildTime={buildTime} isTest={isProd === 'False'}>
        </Application>, root);
}
